// extracted by mini-css-extract-plugin
module.exports = {"sticky":"sticky_sticky__CABJc"};